module.exports = __webpack_public_path__ + "img/migu@2X.da12ba89.png";